module.exports = __webpack_public_path__ + "img/bk.134f9efa.webp";